import Input from "components/Input";

export default class InputPhone extends Input {

    constructor(props) {
        super(props);

        this.inhProps = {
            placeHolder: "^" + this._helper.string.fromatPhone("79000000000"),
            validator: this._helper.inputValidators.phone,
        };
    }

    formatValue() {
        return this.input.value.replace(/\s*/g, "");
    }

    _onFocus(e) {
        if (!this.value)
            this.value = "+7";

        super._onFocus(e);
    }

}
